// initial state
const state = () => ({
    entities: {
        searchText: "",
        pageSize: 20,
        currentPage: 1,
        sort: {
            sortBy: [],
            sortDesc: true,
        },
        entityStatusIDs: [1, 3],
        isProfileCompleted: null,
        vrmAccessTypesIDs: [],
        modules: [],
    },
    users: {
        searchText: "",
        pageSize: 20,
        currentPage: 1,
        sort: {
            sortBy: [],
            sortDesc: true,
        },
        userRoleId: null,
        userStatusIDs: [1, 3],
        isProfileCompleted: null,
        vrmAccessTypesIDs: [],
        modules: [],
        lastLoginDate: null,
    },
});

// getters
const getters = {
    getEntitiesState(state) {
        return state.entities;
    },
    getUsersState(state) {
        return state.users;
    },
};

const actions = {};

// mutations
const mutations = {
    reset(state) {
        state.entities = {
            searchText: "",
            pageSize: 20,
            currentPage: 1,
            sort: {
                sortBy: [],
                sortDesc: "",
            },
            entityStatusIDs: [1, 3],
            isProfileCompleted: null,
            vrmAccessTypesIDs: [],
            modules: [],
        };
        state.users = {
            searchText: "",
            pageSize: 20,
            currentPage: 1,
            sort: {
                sortBy: [],
                sortDesc: true,
            },
            userRoleId: null,
            userStatusIDs: [1, 3],
            isProfileCompleted: null,
            vrmAccessTypesIDs: [],
            modules: [],
            lastLoginDate: null,
        };
    },
    setEntitiesSearchText(state, payload) {
        state.entities.searchText = payload;
    },
    setEntitiesCurrentPage(state, payload) {
        state.entities.currentPage = payload;
    },
    setEntitiesPageSize(state, payload) {
        state.entities.pageSize = payload;
    },
    setEntitiesSort(state, payload) {
        state.entities.sort = payload;
    },
    setEntitiesStatus(state, payload) {
        state.entities.entityStatusIDs = payload;
    },
    setEntitiesAccess(state, payload) {
        state.entities.vrmAccessTypesIDs = payload;
    },
    setEntitiesModules(state, payload) {
        state.entities.modules = payload;
    },
    setEntitiesProfiles(state, payload) {
        state.entities.isProfileCompleted = payload;
    },

    setUsersSearchText(state, payload) {
        state.users.searchText = payload;
    },
    setUsersCurrentPage(state, payload) {
        state.users.currentPage = payload;
    },
    setUsersPageSize(state, payload) {
        state.users.pageSize = payload;
    },
    setUsersSort(state, payload) {
        state.users.sort = payload;
    },
    setUsersStatus(state, payload) {
        state.users.userStatusIDs = payload;
    },
    setUsersAccess(state, payload) {
        state.users.vrmAccessTypesIDs = payload;
    },
    setUsersModules(state, payload) {
        state.users.modules = payload;
    },
    setUsersProfiles(state, payload) {
        state.users.isProfileCompleted = payload;
    },
    setUsersRoleId(state, payload) {
        state.users.userRoleId = payload;
    },
    setUsersLastLoginDate(state, payload) {
        state.users.lastLoginDate = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
